import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import { PostDataAPI } from "../../../../../Services/APIService";
const COLORS = ["#5402A6", "#FF3C3C", "#C0FB9A", "#00C49F", "#FFBB28"];

export default function ProgramBarChart() {
  const [chartData, setChartData] = useState([]);
  const [programKeys, setProgramKeys] = useState([]);

  useEffect(() => {
    loadChartData();
  }, []);

  const loadChartData = () => {
    PostDataAPI("fdngrantcollection/getCollectionChart", "1")
      .then((result) => {
        if (result.success && Array.isArray(result.data) && result.data.length) {
          
          // Extract program names dynamically
          const keys = Object.keys(result.data[0]).filter(
            key => key !== "name"
          );

          setProgramKeys(keys);
          setChartData(result.data);
        } else {
          setChartData([]);
          setProgramKeys([]);
        }
      });
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />

        {programKeys.map((key, index) => (
          <Bar
            key={key}
            dataKey={key}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
